
import { Component, Vue, Prop } from "vue-property-decorator";

import program_routes from "@/api/routes/programs";

@Component({
  name: "CProgramDelete"
})
export default class CProgramDelete extends Vue {
  @Prop({ required: true }) private program_id!: string;

  @Prop({ required: false, default: true })
  public show_btn!: boolean;

  public showDeleteModal() {
    this.$modal.show("delete_program_modal");
  }

  public hideDeleteModal() {
    this.$modal.hide("delete_program_modal");
  }

  public async deleteProgram() {
    return this.$api
      .post(program_routes.archived(this.program_id), {})
      .then(() => {
        this.$router.push({ name: "constructor" });
      })
      .catch(({ response: res }) => {
        this.$notify({
          group: "notifications",
          type: "error",
          text: res.data.error,
          speed: 500
        });
      });
  }
}
